import { PackageOptionUpgradeView } from 'components/OfferPage/PackageUpgrade/PackageUpgradeModal'

function getPackageUpgradePrice(packageUpgrade: PackageOptionUpgradeView, hasFlightsSelected?: boolean, charterBundleRoute?: App.CharterBundleRoute) {
  const totalPrice = packageUpgrade.price + packageUpgrade.package.propertyFees
  // In charter mode, price already includes flights, so don't add flightPrice again
  const totalPriceWithFlights = charterBundleRoute
    ? totalPrice
    : (hasFlightsSelected && packageUpgrade.flightPrice && packageUpgrade.flightsAvailable ? totalPrice + packageUpgrade.flightPrice : totalPrice)
  const totalMemberPrice = packageUpgrade.memberPrice + packageUpgrade.package.propertyFees
  // In charter mode, memberPrice already includes flights, so don't add flightPrice again
  const totalMemberPriceWithFlights = charterBundleRoute
    ? totalMemberPrice
    : (hasFlightsSelected && packageUpgrade.flightPrice && packageUpgrade.flightsAvailable ? totalMemberPrice + packageUpgrade.flightPrice : totalMemberPrice)

  const isSamePrice = totalPrice === totalMemberPrice
  const total = !isSamePrice && packageUpgrade.memberPriceDifference > 0 ? totalMemberPriceWithFlights : totalPriceWithFlights

  return {
    total,
    isSamePrice,
    price: packageUpgrade.priceDifference,
    memberPrice: packageUpgrade.memberPriceDifference,
    duration: packageUpgrade.package.duration,
  }
}

export default getPackageUpgradePrice
